module.exports = __webpack_public_path__ + "static/img/minicons1.3b798daa.png";